export default __webpack_public_path__ + "static/media/settings_notification_img.f3289291.svg";